export const PRELOAD_DATA_API = {
  GET_AVAILABLEPLANS: 'GET_AVAILABLEPLANS',
  RETRIEVE_CART_DETAIL: 'RETRIEVE_CART_DETAIL',
};
